import { BorderBox } from "@/components/atoms/BorderBox";
import { cn } from "@/lib/utils";
import { Droppable } from "@hello-pangea/dnd";
import { ReactNode } from "react";

interface DroppableContainerProps {
    droppableId: string;
    placeholder?: string;
    children?: ReactNode;
    emptyState?: ReactNode;
    borderBoxClassName?: string;
}

export function DroppableContainer({
    droppableId,
    placeholder = "Drop items here",
    children,
    emptyState,
    borderBoxClassName
}: Readonly<DroppableContainerProps>) {
    const hasContent = children !== undefined && children !== null;

    return (
        <Droppable droppableId={droppableId}>
            {(provided, snapshot) => (
                <BorderBox
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={cn(
                        `bg-white border-2 border-dashed min-h-16 ${snapshot.isDraggingOver ? 'bg-blue-50 border-blue-300' : ''
                        }`, borderBoxClassName)}
                >
                    <div className="relative">
                        {hasContent ? (
                            children
                        ) : (
                            emptyState || (
                                <div className="p-2 text-sm text-center text-gray-500 ">
                                    {placeholder}
                                </div>
                            )
                        )}
                        <div className="absolute inset-0 pointer-events-none">
                            {provided.placeholder}
                        </div>
                    </div>
                </BorderBox>
            )}
        </Droppable>
    );
}